import * as React from 'react'
import { FC } from 'react'
import { usePopoverContentData } from '../../hooks'
import { LocationsPopoverContent } from './LocationsPopoverContent'
import { EntityLocationsPopoverContentProps } from '../../typings'

export const EntityLocationsPopoverContentWrapper: FC<
  EntityLocationsPopoverContentProps
> = (props) => {
  const data = usePopoverContentData(props)

  return (
    <LocationsPopoverContent
      billTo={data.billToLocations[0]}
      {...data}
      {...props}
    />
  )
}
EntityLocationsPopoverContentWrapper.displayName =
  'EntityLocationsPopoverContentWrapper'
